import React from "react";
import TaskBoard from "../../components/tasks/TaskBoard";
import { staffApi } from "../../lib/staffApi";
import { saveBlob } from "../finance/invoice-analytics/iaUtils";

export default function StaffTeamTasks() {
  return (
    <div className="space-y-3" data-testid="staff-team-tasks">
      <h1 className="font-heading text-xl">Team tasks</h1>
      <TaskBoard client={staffApi} onSave={saveBlob} hideAll />
    </div>
  );
}
